/* eslint-disable class-methods-use-this */
import { RiUserUnfollowLine } from "@remixicon/react";
import React from "react";
import { DashboardGroupBy } from "../../../__generated__/api";
import Avatar from "../../../components/avatar/Avatar";
import TicketItem from "../ticket-item";
import { GROUP_REGISTRY, GroupBy, GroupDescriptor } from "./base";

export default class AssigneeGroupBy extends GroupBy {
    public static shouldCreate(groupBy: DashboardGroupBy): boolean {
        return groupBy === DashboardGroupBy.Assignee;
    }

    public getGroup(id: string, chats: TicketItem[]): GroupDescriptor {
        const firstChat = chats[0];

        const user = firstChat.chat.assignee;
        return {
            id,
            icon: user ? <Avatar src={user?.avatarUrl as string} /> : (
                <div className="group-letter-icon">
                    <RiUserUnfollowLine />
                </div>
            ),
            title: user ? user?.name as string : "Unassigned",
        };
    }

    public getGroupId(ticket: TicketItem): string | undefined {
        return ticket.chat.assigneeId;
    }
}

GROUP_REGISTRY.register(AssigneeGroupBy);
